import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isDemo, setIsDemo] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('chef_token');
    const saved = localStorage.getItem('chef_user');
    if (token && saved) {
      try {
        setUser(JSON.parse(saved));
        setIsDemo(localStorage.getItem('chef_demo') === 'true');
      } catch { /* ignore */ }
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await API.post('/auth/login', { email, password });
    localStorage.setItem('chef_token', data.token);
    localStorage.setItem('chef_user', JSON.stringify(data.user));
    localStorage.removeItem('chef_demo');
    setUser(data.user);
    setIsDemo(false);
    return data.user;
  }, []);

  const register = useCallback(async (payload) => {
    const { data } = await API.post('/auth/register', payload);
    localStorage.setItem('chef_token', data.token);
    localStorage.setItem('chef_user', JSON.stringify(data.user));
    localStorage.removeItem('chef_demo');
    setUser(data.user);
    setIsDemo(false);
    return data.user;
  }, []);

  const demoLogin = useCallback(async (role) => {
    const { data } = await API.post('/auth/demo-login', { role });
    localStorage.setItem('chef_token', data.token);
    localStorage.setItem('chef_user', JSON.stringify(data.user));
    localStorage.setItem('chef_demo', 'true');
    setUser(data.user);
    setIsDemo(true);
    return data.user;
  }, []);

  const switchRole = useCallback(async () => {
    const newRole = user?.role === 'chef' ? 'resident' : 'chef';
    return demoLogin(newRole);
  }, [user, demoLogin]);

  const logout = useCallback(() => {
    localStorage.removeItem('chef_token');
    localStorage.removeItem('chef_user');
    localStorage.removeItem('chef_demo');
    setUser(null);
    setIsDemo(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, isDemo, login, register, demoLogin, switchRole, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
